export default {
	getAll() {},
}
